import { pageNumberState } from "@/atoms/order/page-number-state";
import { profileState } from "@/atoms/user/profile-state";
import { isNotOpenForSaleModal } from "@/atoms/item/is-not-open-for-sale-modal";
import { isNotOpenDisplayedModal } from "@/atoms/item/is-not-open-displayed-modal";
import { isBatchDiscountModal } from "@/atoms/item/is-batch-discount-modal";
import { ButtonColor } from "@/common/enum/button-color";
import { Permission } from "@/common/enum/permission";
import { BasePageDto } from "@/types/dto/base-page-dto";
import { ItemDetailDto } from "@/types/dto/item-detail-dto";
import { Button, Pagination, Table } from "flowbite-react";
import React from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";

interface Props {
  headersLength: number;
  itemPage: BasePageDto<ItemDetailDto>;
  handlePageChange: (currentPage: number) => void;
  selectedItems: number[];
  onClearSelection: () => void;
  refreshData?: () => void;
}

export const PackageItemMainTableFooter: React.FC<Props> = ({
  headersLength,
  itemPage,
  handlePageChange,
  selectedItems,
  onClearSelection,
  refreshData,
}) => {
  const setPageNumber = useSetRecoilState(pageNumberState);
  const currentUser = useRecoilValue(profileState);
  const setIsNotForSaleModalOpen = useSetRecoilState(isNotOpenForSaleModal);
  const setIsNotDisplayedModalOpen = useSetRecoilState(isNotOpenDisplayedModal);
  const setIsBatchDiscountModalOpen = useSetRecoilState(isBatchDiscountModal);

  const isReadOnlyUser =
    currentUser?.role === "ADMIN" &&
    currentUser?.permission === Permission.READ;

  const handleStartSale = async () => {
    if (selectedItems.length === 0) return;

    const validItems = itemPage.contents.filter(
      (item) => selectedItems.includes(item.id) && item.price > 0
    );

    if (validItems.length === 0) return;

    const firstSelectedItem = validItems[0];

    if (firstSelectedItem) {
      setIsNotForSaleModalOpen({
        ...firstSelectedItem,
        id: -1,
        selectedIds: validItems.map((item) => item.id),
        onSuccess: onClearSelection,
      });
    }
  };

  const handleStartDisplay = async () => {
    if (selectedItems.length === 0) return;

    const validItems = itemPage.contents.filter(
      (item) => selectedItems.includes(item.id) && item.price > 0
    );

    if (validItems.length === 0) return;

    const firstSelectedItem = validItems[0];

    if (firstSelectedItem) {
      setIsNotDisplayedModalOpen({
        ...firstSelectedItem,
        id: -1,
        selectedIds: validItems.map((item) => item.id),
        onSuccess: onClearSelection,
      });
    }
  };

  const handleOpenBatchDiscountModal = () => {
    if (selectedItems.length === 0) return;

    const validItems = itemPage.contents.filter(
      (item) => selectedItems.includes(item.id) && item.price > 0
    );

    if (validItems.length === 0) return;

    setIsBatchDiscountModalOpen({
      isOpen: true,
      selectedIds: validItems.map((item) => item.id),
      onSuccess: () => {
        if (refreshData) {
          refreshData();
        }
        onClearSelection();
      },
    });
  };

  return (
    <Table.Row className="bg-white">
      <Table.Cell colSpan={headersLength}>
        <div className="flex justify-between">
          <div className="flex gap-2 m-[16px]">
            {!isReadOnlyUser && (
              <Button
                size="sm"
                color={ButtonColor.TRANSPARENT_OUTLINE}
                onClick={handleOpenBatchDiscountModal}
                disabled={selectedItems.length === 0}
              >
                상품 일괄 할인
              </Button>
            )}

            <Button
              size="sm"
              color={ButtonColor.TRANSPARENT_OUTLINE}
              onClick={handleStartSale}
              disabled={selectedItems.length === 0}
            >
              선택 상품 판매 시작
            </Button>

            <Button
              size="sm"
              color={ButtonColor.TRANSPARENT_OUTLINE}
              onClick={handleStartDisplay}
              disabled={selectedItems.length === 0}
            >
              선택 상품 진열 시작
            </Button>
          </div>
          <Pagination
            currentPage={itemPage.currentPage}
            totalPages={itemPage.totalPage}
            onPageChange={(currentPage: number) => {
              setPageNumber(currentPage);
              onClearSelection();
              handlePageChange(currentPage);
            }}
            nextLabel=""
            previousLabel=""
            showIcons
          />
        </div>
      </Table.Cell>
    </Table.Row>
  );
};
